"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _react = _interopRequireWildcard(require("react"));
var _xstate = require("xstate");
var _propTypes = require("prop-types");
var _styles = require("../../styles");
var _styles2 = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * The GX API's typeahead endpoint is restricted to one category and one term.
 * As such, the params are named in a way to reflect that.
 * This function converts the `categories` and `terms` params into `category`
 * and `term`, respectively.
 */
const transformQueryStringParams = params => {
  var _context;
  const newParams = {};
  (0, _forEach.default)(_context = (0, _keys.default)(params)).call(_context, param => {
    if (param === 'categories') {
      newParams.category = params[param];
    } else if (param === 'terms') {
      newParams.term = params[param];
    } else {
      newParams[param] = params[param];
    }
  });
  return newParams;
};
const ClinicalSearch = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    productName,
    step,
    onChange,
    templateVariables,
    protocolId
  } = _ref;
  const {
    control,
    question
  } = step;
  const questionTextId = question.replace(/\s/g, '_');
  const exampleId = `${questionTextId}-example`;
  const handleSelect = (0, _react.useCallback)(_ref2 => {
    let {
      value
    } = _ref2;
    onChange({
      step,
      value
    });
  }, [onChange, step]);
  return /*#__PURE__*/_react.default.createElement(_styles.ControlContainer, {
    "data-testid": "GxControl__ClinicalSearch",
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_styles.Question, {
    id: questionTextId,
    content: question,
    replacement: templateVariables
  }), /*#__PURE__*/_react.default.createElement(_styles2.SearchWrapper, null, /*#__PURE__*/_react.default.createElement(_styles2.SearchBox, (0, _extends2.default)({}, control, {
    labelId: questionTextId,
    version: "v9",
    url: `/api/gx/protocol/${protocolId}/typeahead`,
    headers: {
      'x-consumer-username': productName
    },
    categories: ['clinical_keywords'],
    transformQueryStringParams: transformQueryStringParams,
    onSelect: handleSelect,
    "aria-describedby": control.example ? exampleId : undefined
  })), control.example && /*#__PURE__*/_react.default.createElement(_styles2.TypeaheadExample, {
    id: exampleId,
    content: control.example
  })));
});
ClinicalSearch.displayName = 'ClinicalSearch';
ClinicalSearch.propTypes = {
  // product name to pass to typeahead API
  productName: _propTypes.string.isRequired,
  currentState: (0, _propTypes.instanceOf)(_xstate.State).isRequired,
  onChange: _propTypes.func.isRequired,
  step: (0, _propTypes.shape)({
    id: _propTypes.number.isRequired,
    question: _propTypes.string.isRequired,
    control: (0, _propTypes.shape)({
      label: _propTypes.string.isRequired,
      isRequired: _propTypes.bool,
      isRequiredMsg: _propTypes.string
    }).isRequired,
    answer: _propTypes.string
  }),
  templateVariables: _propTypes.object,
  protocolId: _propTypes.number.isRequired
};
var _default = exports.default = ClinicalSearch;
ClinicalSearch.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ClinicalSearch",
  "props": {
    "productName": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "currentState": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "State"
      },
      "required": true
    },
    "onChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "step": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "id": {
            "name": "number",
            "required": true
          },
          "question": {
            "name": "string",
            "required": true
          },
          "control": {
            "name": "shape",
            "value": {
              "label": {
                "name": "string",
                "required": true
              },
              "isRequired": {
                "name": "bool",
                "required": false
              },
              "isRequiredMsg": {
                "name": "string",
                "required": false
              }
            },
            "required": true
          },
          "answer": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "templateVariables": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "protocolId": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    }
  }
};